import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs';
import {
  SeminarDateSeriesListModel,
  SeminarFilterOptionModel,
} from '../../../../../models/seminar.model';
import { FileManagerStateService } from '../../../../../services/file-manager-state.service';
import { SeminarService } from '../../../../../services/seminar.service';

@Component({
  selector: 'app-seminar-attachments',
  templateUrl: './seminar-attachments.component.html',
  styleUrl: './seminar-attachments.component.scss',
  providers: [FileManagerStateService],
  standalone: false,
})
export class SeminarAttachmentsComponent implements OnInit {
  public seminarOptions: SeminarFilterOptionModel[] = [];

  constructor(private seminarService: SeminarService) {}

  ngOnInit(): void {
    this.seminarService
      .getSeminars(true, true)
      .pipe(take(1))
      .subscribe({
        next: (seminars: SeminarDateSeriesListModel[]) => {
          this.seminarOptions = seminars
            .map(seminar => ({
              id: seminar.seminar.id,
              title: seminar.seminar.title,
              dates: seminar.dates,
              isDraft: seminar.seminar.isDraft,
            }))
            .sort((a, b) => a.title.localeCompare(b.title));
        },
        error: () => {},
      });
  }
}
